import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "In this section, you will be able to see how the change of some construction parameters of porous and resonant absorbers influences their frequency dependent absorption coefficients. A section of both types of absorbers is shown below. First chose the porous or resonant absorber type, and observe how the resulting absorption coefficent curve changes with changing some of their parameters.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      rowsSize: [1, 3],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  scrollbars: false,
                  data: "Porous absorber",
                  styles: {
                    textTransform: "uppercase",
                    letterSpacing: "0.25em",
                    fontWeight: 800,
                  },
                },
              },
              styles: {
                alignItems: "flex-end",
                paddingBottom: "8%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  scrollbars: false,
                  data: "resonant absorber",
                  styles: {
                    textTransform: "uppercase",
                    letterSpacing: "0.25em",
                    fontWeight: 800,
                  },
                },
              },
              styles: {
                alignItems: "flex-end",
                paddingBottom: "8%",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/08/principle/porous.svg`,
                },
              },
              styles: {
                paddingBottom: "10%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/08/principle/resonant.svg`,
                },
              },
              styles: {
                paddingBottom: "10%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
